import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { take } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { AuthenticationService } from '@digitalforest/ngx-oak-api';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputTextModule, ButtonModule],
})
export class LoginPageComponent {
  message: string | undefined;

  private router = inject(Router);
  private formBuilder = inject(UntypedFormBuilder);
  private authenticationService = inject(AuthenticationService);
  private authService = inject(AuthService);

  form: UntypedFormGroup = this.formBuilder.group({
    email: new UntypedFormControl(null, [Validators.email, Validators.required]),
    password: new UntypedFormControl(null, [Validators.required]),
  });

  onLogin() {
    const email = this.form.get('email')?.value;
    const password = this.form.get('password')?.value;

    this.authenticationService
      .loginForAccessToken(email, password)
      .pipe(take(1))
      .subscribe({
        next: (value) => {
          this.authService.setToken(value.access_token);
          this.authService.setRefreshToken(value.refresh_token);
          this.router.navigate(environment.loginPageRouterLink).then();
        },
        error: () => {
          this.message = 'Invalid credentials';
        },
      });
  }

  clearMessage() {
    this.message = undefined;
  }
}
